import { Box, Text } from '@ltvco/refresh-lib/theme';
import React, { useEffect } from 'react';

export interface ErrorMessageProps {
  message: string;
  variant?: 'error' | 'warning' | 'info';
  onErrorView?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  variant = 'error',
  onErrorView,
}) => {
  useEffect(() => {
    if (onErrorView) {
      onErrorView();
    }
  }, [onErrorView]);

  const backgroundColorMap = {
    warning: 'warning.light',
    info: 'info.light',
    error: 'error.light',
  } as const;

  const textColorMap = {
    warning: 'warning.dark',
    info: 'info.dark',
    error: 'error.dark',
  } as const;

  const backgroundColor = backgroundColorMap[variant];
  const textColor = textColorMap[variant];

  return (
    <Box
      sx={{
        py: 2,
        px: 3,
        mb: 3,
        backgroundColor,
        borderRadius: 1,
      }}
    >
      <Text variant="body1" color={textColor}>
        {message}
      </Text>
    </Box>
  );
};
